import { acceptHMRUpdate, defineStore } from 'pinia'

import { type GeoIP, type Meta, type SearchResponse, type Session } from '~/types.ts'

type Locations = Record<string, GeoIP | null>

export const useSessions = defineStore('sessions', {
  state: () => ({
    sessions: [] as Session[],
    meta: { pageSize: 10 } as Meta,
    fetched: false,
    locations: {} as Locations,
  }),

  actions: {
    async paginate(page: number) {
      try {
        await stores.loading.update({ sessions: true })
        const { data } = await api.post<SearchResponse<Session>>('sessions', { page, per_page: this.meta.pageSize })

        this.sessions = data.data
        assignMetaFromResponseData(this.meta, data)
        this.fetched = true
      } catch {
        $message.error($t('api-error'))
      } finally {
        await stores.loading.update({ sessions: false })
      }
    },

    async getLocations(sessions: Session[]) {
      const locations: Locations = {}

      for (const session of sessions) {
        if (!(session.ip_address in this.locations) && !(session.ip_address in locations)) {
          try {
            const { data }: { data: GeoIP } = await api.get(`geoip/${session.ip_address}`)
            locations[session.ip_address] = data
          } catch {
            locations[session.ip_address] = null
          }
        }
      }

      if (Object.keys(locations).length > 0) {
        this.locations = { ...this.locations, ...locations }
      }
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSessions, import.meta.hot))
}
